"use strict";

exports.analyticsApiClient = function (e) {
  var t = function t(e) {
    window && window.sendEvent && window.sendEvent(e);
  };
  return {
    sendCustom: function sendCustom(e) {
      Object.prototype.hasOwnProperty.call(e, "name") && Object.prototype.hasOwnProperty.call(e, "params") && 2 === Object.keys(e).length && t(e);
    },
    sendError: function sendError(n) {
      t({
        event_category: "error",
        event_action: e,
        event_label: n
      });
    },
    sendEvent: function sendEvent(n, o, a) {
      var i = {
        event_category: a || "self_serve_actions",
        event_label: "string" == typeof n.label ? n.label : "",
        event_action: "string" == typeof n.action ? n.action : e
      };
      o && Object.keys(o).length > 0 && (i.custom = o), t(i);
    },
    sendPageview: function sendPageview(e) {
      if (window && window.location) {
        var n = {
          event_category: "pageview",
          page_path: window.location.pathname || "",
          page_location: window.location.href || ""
        };
        e && Object.keys(e).length > 0 && (n.custom = e), t(n);
      }
    }
  };
};